/* Fellino presentation for Shopify's native consent UI.
 * Shopify alone manages consent, persistence, focus and pixel permissions.
 * This file never writes consent or cookies, nor changes checkbox values.
 */
(() => {
  'use strict';
  const locale = document.documentElement.lang.split('-')[0];
  if (!['de', 'en'].includes(locale)) return;
  const de = locale === 'de';
  const copy = de ? {
    eyebrow: 'FELLINO · DEINE PRIVATSPHÄRE',
    title: 'Deine Privatsphäre zählt.',
    intro: 'Notwendige Cookies ermöglichen Warenkorb, Anmeldung und Sicherheit. Mit deiner Einwilligung nutzen wir und unsere Partner, einschließlich Shopify, zusätzliche Cookies und ähnliche Technologien für Personalisierung, Analysen und Werbung.',
    choice: 'Du entscheidest: alle optionalen Cookies akzeptieren, ablehnen oder einzeln auswählen. Einkaufen geht auch ohne sie.',
    withdraw: 'Jederzeit ändern oder für die Zukunft widerrufen: über „Cookie-Einstellungen“ am Seitenende.',
    accept: 'Alle akzeptieren', reject: 'Alle ablehnen', manage: 'Auswahl anpassen', save: 'Auswahl speichern',
    prefsTitle: 'Cookie-Einstellungen', prefsIntro: 'Du entscheidest, was du erlaubst.',
    prefsBody: 'Wähle die optionalen Kategorien und bestätige mit „Auswahl speichern“. „Alle ablehnen“ widerruft auch eine frühere Zustimmung. Schließen ohne Speichern lässt deine bisherige Auswahl unverändert.',
    close: 'Schließen ohne Speichern', privacy: 'Datenschutzerklärung', legal: 'Impressum',
    essential: 'Immer aktiv: für Warenkorb, Anmeldung, Sicherheit und das Speichern deiner Cookie-Auswahl. Diese notwendigen Funktionen lassen sich hier nicht abschalten.',
    preferences: 'Diese optionalen Cookies merken sich Einstellungen und helfen dabei, deinen nächsten Besuch zu personalisieren.',
    analytics: 'Diese optionalen Cookies helfen uns und unseren Dienstleistern zu verstehen, wie der Shop genutzt wird und was wir verbessern können.',
    marketing: 'Diese optionalen Cookies werden von uns und unseren Werbepartnern, einschließlich Shopify, für personalisierte Werbung und die Messung von Werbekampagnen genutzt – auch auf anderen Websites.',
    footer: 'Cookie-Einstellungen', footerLabel: 'Cookie-Einstellungen öffnen und Einwilligung widerrufen'
  } : {
    eyebrow: 'FELLINO · YOUR PRIVACY', title: 'Your privacy matters.',
    intro: 'Necessary cookies support your basket, sign-in and security. With your consent, we and our partners, including Shopify, use additional cookies and similar technologies for personalization, analytics and advertising.',
    choice: 'Your choice: accept all optional cookies, reject them or choose individual categories. You can shop without them.',
    withdraw: 'Change or withdraw your consent for the future at any time via “Cookie settings” at the bottom of the page.',
    accept: 'Accept all', reject: 'Reject all', manage: 'Customize selection', save: 'Save selection',
    prefsTitle: 'Your cookie settings', prefsIntro: 'You decide what to allow.',
    prefsBody: 'Choose optional categories and confirm with “Save selection”. “Reject all” also withdraws previous consent. Closing without saving leaves your previous choice unchanged.',
    close: 'Close without saving', privacy: 'Privacy policy', legal: 'Legal notice',
    essential: 'Always active: for your basket, sign-in, security and remembering your cookie choice. These necessary functions cannot be switched off here.',
    preferences: 'These optional cookies remember settings and help personalize your next visit.',
    analytics: 'These optional cookies help us and our service providers understand how the shop is used and how to improve it.',
    marketing: 'These optional cookies are used by us and our advertising partners, including Shopify, for personalized advertising and measuring campaigns, including on other websites.',
    footer: 'Cookie settings', footerLabel: 'Open cookie settings and withdraw consent'
  };
  const text = (selector, value, root = document) => {
    const el = root.querySelector(selector);
    if (el && el.textContent !== value) el.textContent = value;
  };
  const paragraph = (parent, className, value) => {
    let el = parent.querySelector('.' + className);
    if (!el) { el = document.createElement('p'); el.className = className; parent.append(el); }
    if (el.textContent !== value) el.textContent = value;
  };
  const legalLinks = parent => {
    if (parent.querySelector('.fl-privacy-links')) return;
    const nav = document.createElement('div'); nav.className = 'fl-privacy-links';
    const footer = document.querySelector('.fl-footer');
    for (const [path, label] of [['privacy-policy', copy.privacy], ['legal-notice', copy.legal]]) {
      const link = document.createElement('a');
      link.href = footer?.querySelector(`a[href$="/policies/${path}"]`)?.href || `/policies/${path}`;
      link.textContent = label; nav.append(link);
    }
    parent.append(nav);
  };
  function enhance() {
    const banner = document.querySelector('#shopify-pc__banner');
    if (banner) {
      const body = banner.querySelector('.shopify-pc__banner__body');
      if (body && !body.dataset.fellinoPrivacy) {
        body.dataset.fellinoPrivacy = 'true';
        const eyebrow = document.createElement('span'); eyebrow.className = 'fl-privacy-eyebrow'; eyebrow.textContent = copy.eyebrow;
        body.prepend(eyebrow);
        text('h2', copy.title, body);
        // Replace only the native explanatory paragraph, preserving all controls.
        text('p', copy.intro, body);
        paragraph(body, 'fl-privacy-choice', copy.choice);
        paragraph(body, 'fl-privacy-withdraw', copy.withdraw);
        legalLinks(body);
      }
      text('#shopify-pc__banner__btn-accept', copy.accept);
      text('#shopify-pc__banner__btn-decline', copy.reject);
      text('#shopify-pc__banner__btn-manage-prefs', copy.manage);
    }
    const prefs = document.querySelector('#shopify-pc__prefs__dialog');
    if (prefs) {
      text('#shopify-pc__prefs__header-title', copy.prefsTitle);
      text('#shopify-pc__prefs__header-accept', copy.accept);
      text('#shopify-pc__prefs__header-decline', copy.reject);
      text('#shopify-pc__prefs__header-save', copy.save);
      const close = prefs.querySelector('#shopify-pc__prefs__header-close');
      if (close) close.setAttribute('aria-label', copy.close);
      const intro = prefs.querySelector('.shopify-pc__prefs__intro-main');
      if (intro && !intro.dataset.fellinoPrivacy) {
        intro.dataset.fellinoPrivacy = 'true';
        text('h3', copy.prefsIntro, intro); text('p', copy.prefsBody, intro);
        paragraph(intro, 'fl-privacy-withdraw', copy.withdraw); legalLinks(intro);
      }
      ['essential', 'preferences', 'analytics', 'marketing'].forEach(type => {
        const option = prefs.querySelector(`#shopify-pc__prefs__${type}`);
        if (!option) return;
        text('p', copy[type], option);
        const description = option.querySelector('p');
        const input = option.querySelector('input');
        if (description && input) {
          description.id = `fl-privacy-description-${type}`;
          input.setAttribute('aria-describedby', description.id);
        }
      });
    }
    document.querySelectorAll('[data-cookie-preferences]').forEach(button => {
      if (button.textContent !== copy.footer) button.textContent = copy.footer;
      button.setAttribute('aria-label', copy.footerLabel);
      button.setAttribute('aria-haspopup', 'dialog');
    });
  }
  let pending = false;
  const observer = new MutationObserver(records => {
    const relevant = records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 &&
      (node.matches?.('[id^="shopify-pc__"], [data-cookie-preferences]') || node.querySelector?.('[id^="shopify-pc__"], [data-cookie-preferences]'))));
    if (!relevant || pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; enhance(); });
  });
  const start = () => { enhance(); observer.observe(document.body, { childList: true, subtree: true }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
